import React from 'react'
import { Backdrop } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Loader } from 'packages/eid-ui'

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        backdropFilter: 'blur(8px)',
    },
}))

const FullScreenLoader = () => {
    const classes = useStyles()

    return (
        <Backdrop className={classes.backdrop} open={true}>
            <Loader />
        </Backdrop>
    )
}

export default FullScreenLoader
